/* ============================================================
   THE FOUNDERS STUDIO · section library behaviour
   Reveal, accordion, slider, count up, image fader.
   Re-initialises on Shopify theme editor section loads.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = root.querySelectorAll('.fs-rise, .fs-zoom, [data-fs-count]');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); if (el.hasAttribute('data-fs-count')) countUp(el, true); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        if (e.target.hasAttribute('data-fs-count')) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function countUp(el, instant) {
    if (el.dataset.fsDone) return;
    el.dataset.fsDone = '1';
    var raw = el.getAttribute('data-fs-count');
    var m = raw.match(/^(\D*)([\d,.]+)(.*)$/);
    if (!m) { el.textContent = raw; return; }
    var pre = m[1], numStr = m[2], post = m[3];
    var decimals = (numStr.split('.')[1] || '').length;
    var target = parseFloat(numStr.replace(/,/g, ''));
    var useComma = numStr.indexOf(',') > -1;
    function fmt(v) {
      var s = v.toFixed(decimals);
      if (useComma) { var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); s = p.join('.'); }
      return pre + s + post;
    }
    if (instant) { el.textContent = fmt(target); return; }
    var start = null, dur = 1600;
    function step(ts) {
      if (!start) start = ts;
      var t = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt(target * eased);
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function accordions(root) {
    root.querySelectorAll('[data-fs-acc]').forEach(function (acc) {
      if (acc.dataset.fsInit) return; acc.dataset.fsInit = '1';
      var single = acc.getAttribute('data-fs-acc') === 'single';
      acc.querySelectorAll('.fs-acc-q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.fs-acc-item');
          var open = !item.classList.contains('is-open');
          if (single) acc.querySelectorAll('.fs-acc-item.is-open').forEach(function (o) {
            o.classList.remove('is-open'); o.querySelector('.fs-acc-q').setAttribute('aria-expanded', 'false');
          });
          item.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  function sliders(root) {
    root.querySelectorAll('[data-fs-slider]').forEach(function (s) {
      if (s.dataset.fsInit) return; s.dataset.fsInit = '1';
      var track = s.querySelector('.fs-slider__track');
      if (!track) return;
      function by(dir) {
        var slide = track.querySelector('.fs-slide');
        var w = slide ? slide.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      var p = s.querySelector('.fs-slider__nav--prev'), n = s.querySelector('.fs-slider__nav--next');
      if (p) p.addEventListener('click', function () { by(-1); });
      if (n) n.addEventListener('click', function () { by(1); });
    });
  }

  function faders(root) {
    root.querySelectorAll('[data-fs-fader]').forEach(function (f) {
      if (f.dataset.fsInit) return; f.dataset.fsInit = '1';
      var slides = f.querySelectorAll('.fs-media');
      if (slides.length < 2 || reduce) return;
      var i = 0, ms = parseInt(f.getAttribute('data-fs-fader'), 10) || 3800;
      setInterval(function () {
        slides[i].classList.remove('is-on');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-on');
      }, ms);
    });
  }

  function newsletter(root) {
    root.querySelectorAll('.fs-news form').forEach(function (form) {
      var first = form.querySelector('[data-fs-first]');
      var note = form.querySelector('input[name="contact[note]"]');
      if (!first || !note) return;
      form.addEventListener('submit', function () { note.value = 'First name: ' + first.value; });
    });
  }

  function init(root) {
    root = root || document;
    reveal(root); accordions(root); sliders(root); faders(root); newsletter(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('.fs-acc-item');
    if (item) item.classList.add('is-open');
  });
})();
